<!--START: header-->
<landing-app-header></landing-app-header>
<!--END: header-->


<div class="sub-hero-section wf-section">
  <div class="container">
    <div class="hero-title-center flex-inner">
      <div data-w-id="cc7fbcb1-7c34-6699-cb77-e583828267eb" class="tag-text">what we do</div>
      <div class="margin-20px">
        <h1 data-w-id="cc7fbcb1-7c34-6699-cb77-e583828267ee" class="hero-title color-white">We do <span class="add-scribble-below">awesome</span><br/> things<span class="add-scribble-below">‍</span><br></h1>
      </div>
    </div>
    <div class="margin-70px">
      <div class="container">
        <div class="features-grid">
          <div data-w-id="4d5f7307-17c2-6bac-0068-f309ec08877c" class="features-photo"></div>
          <div id="w-node-_4d5f7307-17c2-6bac-0068-f309ec08877d-c152964f" class="boxes-grid">
            <div data-w-id="4d5f7307-17c2-6bac-0068-f309ec08877e" class="features-content">
              <img src="assets/img/icons8-web-design-512.png" width="50" alt="">
              <h3>Professionally Designed Demos<br></h3>
              <p>Pixel perfect &amp; expertly crafted to meet standards.<br></p>
            </div>
            <div data-w-id="4d5f7307-17c2-6bac-0068-f309ec088786" class="features-content">
              <img src="assets/img/icons8-smartphone-tablet-512.png" width="50" sizes="50px" srcset="assets/img/icons8-smartphone-tablet-512-p-500.png 500w, assets/img/icons8-smartphone-tablet-512.png 512w" alt="">
              <h3>Responsive On Any Device<br></h3>
              <p>Showcase your site on all devices with confidence.<br></p>
            </div>
            <div data-w-id="4d5f7307-17c2-6bac-0068-f309ec08878e" class="features-content">
              <img src="assets/img/icons8-online-support-512.png" width="50" sizes="50px" srcset="assets/img/icons8-online-support-512-p-500.png 500w, assets/img/icons8-online-support-512.png 512w" alt="">
              <h3>Professional, World-Class Support<br></h3>
              <p>We love what we do &amp; who we do it for.<br></p>
            </div>
            <div data-w-id="4d5f7307-17c2-6bac-0068-f309ec088796" class="features-content">
              <img src="assets/img/icons8-view-quilt-512.png" width="50" alt="">
              <h3>Unlimited Layouts &amp; Designs<br></h3>
              <p>Design anything. The only limit is your imagination.<br></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div><img src="assets/img/scribbles-3.png" width="60" data-w-id="cc7fbcb1-7c34-6699-cb77-e583828267f7" sizes="100vw" srcset="assets/img/scribbles-3-p-500.png 500w, assets/img/scribbles-3.png 608w" alt="" class="scribble-2"><img src="assets/img/scribbles-2.png" width="120" data-w-id="cc7fbcb1-7c34-6699-cb77-e583828267f8" sizes="(max-width: 991px) 80px, 120px" srcset="assets/img/scribbles-2-p-500.png 500w, assets/img/scribbles-2-p-800.png 800w, assets/img/scribbles-2.png 1036w" alt="" class="scribble-1">
</div>
<div class="section wf-section">
  <div class="container">
    <div>
      <div>
        <div class="features-second-grid">
          <div class="features-content padding-box">
            <img src="assets/img/icons8-web-design-512.png" width="50" alt="">
            <h3>Professionally Designed Demos<br></h3>
            <p>Pixel perfect &amp; expertly crafted to meet standards.<br></p>
          </div>
          <div class="features-content padding-box">
            <img src="assets/img/icons8-smartphone-tablet-512.png" width="50" sizes="50px" srcset="assets/img/icons8-smartphone-tablet-512-p-500.png 500w, assets/img/icons8-smartphone-tablet-512.png 512w" alt="">
            <h3>Responsive On Any Device<br></h3>
            <p>Showcase your site on all devices with confidence.<br></p>
          </div>
          <div class="features-content padding-box">
            <img src="assets/img/icons8-online-support-512.png" width="50" sizes="50px" srcset="assets/img/icons8-online-support-512-p-500.png 500w, assets/img/icons8-online-support-512.png 512w" alt="">
            <h3>Professional, World-Class Support<br></h3>
            <p>We love what we do &amp; who we do it for.<br></p>
          </div>
        </div>
      </div>
      <div class="margin-50px">
        <div class="contribute-wrapper">
          <div class="tag-text">New Features</div>
          <p class="cookies-font check features-tag">If you want to join the effort and help with the plugin, please <a href="mailto:hello&#64;merchloop.com">let us know</a>.</p>
        </div>
      </div>
      <div class="margin-block">
        <div class="illustrator-grid">
          <div class="illustration"><img src="assets/img/Illustration-2.png" width="750" data-w-id="2e3ef474-b75e-6656-9d6b-32e283d9392a" sizes="100vw" srcset="assets/img/Illustration-2-p-500.png 500w, assets/img/Illustration-2-p-800.png 800w, assets/img/Illustration-2-p-1080.png 1080w, assets/img/Illustration-2.png 1500w" alt=""></div>
          <div id="w-node-_2e3ef474-b75e-6656-9d6b-32e283d9392b-c152964f" class="list-circle-wrapper">
            <div class="list-flex">
              <div class="list-item">
                <div class="number-text">1</div>
                <p><strong>We have a bias for action. </strong>We act fast with clear priorities. We value speed, but take time to reflect when required.<br></p>
              </div>
              <div class="list-item">
                <div class="number-text">2</div>
                <p><strong>We value diversity of thought. </strong>We believe that a variety of ideas encourages newer and more forward-thinking solutions. We leverage unique talents and insights.<br></p>
              </div>
              <div class="list-item no-bottom-line">
                <div class="number-text">3</div>
                <p><strong>We love our team. </strong>We support each other and ask for help when we are stuck. We value a good laugh during and outside of work. And yes, you can wear your pink unicorn suit to work.<br></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--START: Footer-->
<landing-app-footer></landing-app-footer>
<!--END: Footer-->
